import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { nullSafe } from "../../utils";
import { EosApiException } from "../api.gen";
import { AuthService } from "../auth.service";
import { ToastService } from '../toast.service';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private toast: ToastService, private authService: AuthService) { }

  private getErrCode(key: number): string {
    switch (key) {
      case 400:
        return 'Bad request. Validation at server side failed.';
      case 401:
      case 403:
        return 'You are not authorized to perform this action.';
      case 500:
      default:
        return 'Exception occured at the server, please contact the application administrator for more details.';
    }
  };
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type === "application/json") {
          // https://github.com/angular/angular/issues/19888
          // When request of type Blob, the error is also in Blob instead of object of the json data
          return new Promise<any>((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (e: Event) => {
              try {
                const errmsg = <EosApiException>(JSON.parse((<any>e.target).result));

                const isEosEx = nullSafe(() => errmsg.type == 'eos-ex', false);
                const hasErrCode = nullSafe(() => errmsg.errorCode >0, -1);
                if (isEosEx && hasErrCode && errmsg.errorCode == 1005) {
                  this.authService.logout();
                }

                reject(new HttpErrorResponse({
                  error: errmsg,
                  headers: err.headers,
                  status: err.status,
                  statusText: err.statusText,
                  url: err.url
                }));
              } catch (e) {
                reject(err);
              }
            };
            reader.onerror = (e) => {
              reject(err);
            };
            reader.readAsText(err.error);
          });
        }
        return throwError(err);
      })
    );
  }
}
